/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import { EmptyCardProps } from './types';
import TEmptyCard, { EmptyCardAnalytics } from './EmptyCard';

const EmptyCard: React.FC<EmptyCardProps> = ({
  trackId,
  trackCategory,
  trackedHandlers,
  untrackedHandlers,
  stopTracking,
  canReturnParams,
  ...rest
}) => {
  if (trackId) {
    return (
      <EmptyCardAnalytics
        trackId={trackId}
        trackCategory={trackCategory}
        trackedHandlers={trackedHandlers}
        untrackedHandlers={untrackedHandlers}
        stopTracking={stopTracking}
        canReturnParams={canReturnParams}
        {...rest}
      />
    );
  }
  return <TEmptyCard {...rest} />;
};

export type { EmptyCardProps };
export default EmptyCard;
